import ReportPopup from './ReportPopup';

export default ReportPopup;
